import React from 'react'
import styled from 'styled-components'
import { mixins } from '../css-variables'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Wrapper from '../parts/Wrapper'

const CardE = ({
    className,
    img,
    width,
    fooImage,
    alt,
    caption,
    marginTop,
    center,
    enhancedHomepageCaption,
    pillar,
    link,
}) => {
    const marginTopClass = marginTop ? ' marginTop' : ''
    const centerClass = center ? ' center' : ''
    const enhancedHomepageCaptionClass = enhancedHomepageCaption
        ? ' enhancedHomepageCaption'
        : ''
    const pillarClass = pillar ? ' pillar' : ''
    const image = img ? getImage(img) : null

    const figure = (
        <figure>
            {image && (
                <GatsbyImage
                    image={image}
                    alt={alt || ''}
                    layout="constrained"
                    width={width}
                />
            )}
            {fooImage && <img alt={alt || ''} src={fooImage} />}
            <figcaption
                className={`${marginTopClass} ${centerClass} ${enhancedHomepageCaptionClass}`}>
                {caption}
            </figcaption>
        </figure>
    )

    return (
        <Wrapper
            href={link ?? undefined}
            className={`${className}${pillarClass} text-decoration-none`}
            parent={link ? 'a' : 'div'}>
            {figure}
        </Wrapper>
    )
}

const StyledCardE = styled(CardE)`
    ${mixins.imageWithCaption}
`

export default StyledCardE
